import { render, staticRenderFns } from "./purchase-contract-info.vue?vue&type=template&id=56960140&"
import script from "./purchase-contract-info.vue?vue&type=script&lang=js&"
export * from "./purchase-contract-info.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/www/stage-dev1/front/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('56960140')) {
      api.createRecord('56960140', component.options)
    } else {
      api.reload('56960140', component.options)
    }
    module.hot.accept("./purchase-contract-info.vue?vue&type=template&id=56960140&", function () {
      api.rerender('56960140', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/products/commercial/partials/purchase-contract-info.vue"
export default component.exports